﻿import { generateCsr } from "../crypto/certificates";
import { isMultipleDomainTextValid } from '../utils/domainHelper';

var domainText = document.getElementById("domain-text") as HTMLInputElement;
var generateButton = document.getElementById("generate-csr") as HTMLButtonElement;
var csrInfoContainer = document.getElementById("csr-info-container") as HTMLDivElement;
var csrText = document.getElementById("csr-text") as HTMLTextAreaElement;
var privateKeyText = document.getElementById("private-key-text") as HTMLTextAreaElement;
var downloadCsrButton = document.getElementById("download-csr") as HTMLButtonElement;
var downloadPrivateKeyButton = document.getElementById("download-private-key") as HTMLButtonElement;

domainText.addEventListener("keyup", (evt) => {
    if (isMultipleDomainTextValid(domainText.value)) {
        generateButton.disabled = false;
        if (evt.keyCode == 13) {
            generateCsrClicked();
        }
    }
    else {
        generateButton.disabled = true;
    }
});

var generateCsrClicked = async () => {
    var domainValues = domainText.value;
    var stuff = await generateCsr(domainValues);
    csrText.value = stuff.csr;
    privateKeyText.value = stuff.privateKey;
    csrInfoContainer.style.display = "block";
}

generateButton.addEventListener("click", generateCsrClicked)

downloadCsrButton.addEventListener("click", () => {
    var text = csrText.value;
    var file = new File([text], "signing-request.csr");
    var downloadUrl = URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'signing-request.csr'; // The desired filename for the JS file

    document.body.appendChild(link); // Append to DOM to make it clickable
    link.click(); // Programmatically click the link to trigger download
    setTimeout(() => {
        document.body.removeChild(link); // Clean up the DOM
        URL.revokeObjectURL(downloadUrl); // Release the object URL
    }, 100);
})

downloadPrivateKeyButton.addEventListener("click", () => {
    var text = privateKeyText.value;
    var file = new File([text], "private.key");
    var downloadUrl = URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = "private.key"; // The desired filename for the JS file

    document.body.appendChild(link); // Append to DOM to make it clickable
    link.click(); // Programmatically click the link to trigger download
    setTimeout(() => {
        document.body.removeChild(link); // Clean up the DOM
        URL.revokeObjectURL(downloadUrl); // Release the object URL
    }, 100);
})